(function ($) {
	'use strict';

	$(function () {
		const token = $('meta[name="csrf-token"]').attr('content');
		let toastTimer = null;

		function toast(message) {
			let $toast = $('[data-saved-resume-toast]');
			if (!$toast.length) {
				$toast = $('<div class="saved-resume-toast" data-saved-resume-toast></div>').appendTo('body');
			}

			$toast.text(message).addClass('is-visible');
			clearTimeout(toastTimer);
			toastTimer = setTimeout(function () {
				$toast.removeClass('is-visible');
			}, 4200);
		}

		function updateButton($button, saved) {
			$button.toggleClass('is-saved', saved)
				.attr('data-saved', saved ? '1' : '0')
				.attr('title', saved ? window.___('Прибрати резюме зі збережених') : window.___('Зберегти кандидата'))
				.attr('aria-label', saved ? window.___('Прибрати резюме зі збережених') : window.___('Зберегти кандидата'));
			$button.find('span').text(saved ? window.___('Збережено') : ($button.data('short') ? window.___('Зберегти') : window.___('Зберегти кандидата')));
		}

		function setLoading($button, loading) {
			$button.prop('disabled', loading).toggleClass('is-loading', loading);
		}

		function updateCounter(selector, delta) {
			const $counter = $(selector);
			if (!$counter.length) return;
			const current = parseInt($counter.text(), 10) || 0;
			$counter.text(Math.max(0, current + delta));
		}

		function initSelects() {
			$('.saved-resumes-filter select').each(function () {
				const $select = $(this);
				if ($select.next('.saved-resumes-select-dropdown').length) return;

				const $dropdown = $('<div class="custom-dropdown resume-select-dropdown employer-select-dropdown jobs-select-dropdown saved-resumes-select-dropdown"></div>');
				const $selected = $('<div class="dropdown-selected" tabindex="0"></div>');
				const $options = $('<ul class="dropdown-list text-[13px] bg-white dark:bg-slate-900 dark:shadow-gray-800"></ul>');

				$select.find('option').each(function () {
					const $option = $(this);
					$('<li></li>').text($option.text()).attr('data-value', $option.val()).appendTo($options);
				});

				$select.addClass('employer-native-select');
				$dropdown.append($selected, $options).insertAfter($select);

				function refresh() {
					const value = $select.val();
					$selected.text($select.find('option:selected').text());
					$options.find('li').removeClass('is-active').filter(function () {
						return String($(this).attr('data-value')) === String(value);
					}).addClass('is-active');
				}

				$selected.on('click keydown', function (event) {
					if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
					event.preventDefault();
					$('.saved-resumes-select-dropdown .dropdown-list').not($options).hide();
					$options.toggle();
				});

				$options.on('click', 'li', function () {
					$select.val($(this).attr('data-value')).trigger('change');
					$options.hide();
					refresh();
				});

				$select.on('change', refresh);
				refresh();
			});
		}

		$(document).on('click', '.js-save-resume', function () {
			const $button = $(this);
			if ($button.prop('disabled')) return;

			const wasSaved = String($button.attr('data-saved')) === '1';
			const url = wasSaved ? $button.data('unsave-url') : $button.data('save-url');

			setLoading($button, true);

			$.ajax({
				url: url,
				method: wasSaved ? 'DELETE' : 'POST',
				dataType: 'json',
				headers: {
					'X-CSRF-TOKEN': token,
					'Accept': 'application/json'
				}
			}).done(function (response) {
				updateButton($button, !!response.saved);
				toast(response.message || (response.saved ? window.___('Кандидата збережено.') : window.___('Кандидата прибрано зі збережених.')));
			}).fail(function (xhr) {
				if (xhr.status === 401) {
					window.location.href = '/employers/login';
					return;
				}
				toast(window.___('Не вдалося оновити збереження. Спробуйте ще раз.'));
			}).always(function () {
				setLoading($button, false);
			});
		});

		$(document).on('click', '.js-remove-saved-resume', function () {
			const $button = $(this);
			const $card = $button.closest('[data-saved-resume-card]');
			if ($button.prop('disabled')) return;

			setLoading($button, true);

			$.ajax({
				url: $button.data('remove-url'),
				method: 'DELETE',
				dataType: 'json',
				headers: {
					'X-CSRF-TOKEN': token,
					'Accept': 'application/json'
				}
			}).done(function (response) {
				updateCounter('[data-saved-resume-total]', -1);
				if (String($card.data('available')) === '1') updateCounter('[data-saved-resume-available]', -1);
				if (String($card.data('updated')) === '1') updateCounter('[data-saved-resume-updated]', -1);
				toast(response.message || window.___('Резюме прибрано зі збережених.'));
				$card.slideUp(180, function () {
					$card.remove();
					if (!$('[data-saved-resume-card]').length) {
						$('[data-saved-resumes-empty-after-remove]').removeClass('hidden');
					}
				});
			}).fail(function () {
				toast(window.___('Не вдалося прибрати резюме. Спробуйте ще раз.'));
				setLoading($button, false);
			});
		});

		$(document).on('click', '.js-save-resume-login', function (event) {
			event.preventDefault();
			toast(window.___('Увійдіть як роботодавець, щоб зберігати кандидатів.'));
			const href = $(this).attr('href');
			window.setTimeout(function () {
				window.location.href = href;
			}, 900);
		});

		$(document).on('click', '[data-saved-resumes-filter-toggle]', function () {
			$('.js-saved-resumes-filter').toggleClass('is-open');
		});

		$(document).on('click', function (event) {
			if (!$(event.target).closest('.saved-resumes-select-dropdown').length) {
				$('.saved-resumes-select-dropdown .dropdown-list').hide();
			}
		});

		initSelects();
	});
})(jQuery);
